import api, { apiBaseUrl } from '@/store/helpers/api';

export default {
  state: {
    loading: false,
    customer: null,
    apiBaseUrl,
    fontsLoaded: ['Roboto'],
    googleFonts: [],
    googleFontsPromise: null,
    customerSettings: {
      crmToken: '',
      crmUrl: '',
      letsbookUrl: '',
      letsbookApiId: '',
      letsbookLandingPageId: '',
      domain: [],
      lgpdRecipients: [],
      emails: {},
      bodyFont: 'Raleway',
      headingFont: 'Raleway',
      gtm: '',
      favicon: '',
    },
  },
  mutations: {
    SET_LOADING_STATE(state, loading) {
      state.loading = loading;
    },
    SET_CUSTOMER(state, customer) {
      state.customer = customer;
    },
    SET_CUSTOMER_SETTINGS(state, customerSettings) {
      state.customerSettings = customerSettings;
    },
    SET_GOOGLE_FONTS(state, googleFonts) {
      state.googleFonts = googleFonts;
    },
    SET_GOOGLE_FONTS_PROMISE(state, googleFontsPromise) {
      state.googleFontsPromise = googleFontsPromise;
    },
    ADD_FONT_LOADED(state, fontFamily) {
      state.fontsLoaded.push(fontFamily);
    },
  },
  getters: {
    settings: (state, getters) => ({
      ...state.customerSettings,
      ...getters.containerSettings,
    }),
    siteHostname: (state) => {
      if (state.customerSettings.domain.length > 0) {
        return state.customerSettings.domain[0];
      }

      return `${state.customer}.siteletsbook.com.br`;
    },
    hasLetsbookIntegration: (state) => {
      const { letsbookUrl, letsbookApiId, letsbookLandingPageId } =
        state.customerSettings;

      return Boolean(letsbookUrl && letsbookApiId && letsbookLandingPageId);
    },
    hasCRMIntegration: (state) => Boolean(state.customerSettings.crmToken),
  },
  actions: {
    loadCustomerSettings({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING_STATE', true);

        api
          .get('settings')
          .then((response) => {
            const settings = {
              ...state.customerSettings,
              ...response.data,
            };
            commit('SET_CUSTOMER_SETTINGS', settings);
            resolve(settings);
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    saveCustomerSettings({ commit, state }, settingsToUpdate) {
      commit('SET_LOADING_STATE', true);

      return api
        .put('settings', settingsToUpdate)
        .then(() => {
          const updatedCustomerSettings = {
            ...state.customerSettings,
            ...settingsToUpdate,
          };
          commit('SET_CUSTOMER_SETTINGS', updatedCustomerSettings);
        })
        .catch((error) => console.log(error))
        .finally(() => commit('SET_LOADING_STATE', false));
    },
    loadFont({ commit, state }, fontFamily) {
      if (fontFamily !== 'global' && !state.fontsLoaded.includes(fontFamily)) {
        const link = document.createElement('link');
        link.href = `https://fonts.googleapis.com/css2?family=${fontFamily}:wght@200;300;400;500;600;700;800&display=swap`;
        link.rel = 'stylesheet';
        document.head.append(link);

        commit('ADD_FONT_LOADED', fontFamily);
      }
    },
    loadGoogleFonts({ commit, state }) {
      if (state.googleFontsPromise) {
        return state.googleFontsPromise;
      }

      // Ref: https://developers.google.com/fonts/docs/developer_api
      const googleFontsPromise = new Promise((resolve, reject) => {
        const baseUrl =
          'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyCoYS973pNtH3ZX_KBUMw1WTP3KET1eeso';
        fetch(`${baseUrl}&sort=popularity&fields=items.family,items.subsets`)
          .then((res) => res.json())
          .then((data) => {
            const fonts = data.items
              .filter(
                (font) =>
                  font.subsets.includes('latin') &&
                  !font.family.includes('Barcode') &&
                  !font.family.includes('Noto Sans'),
              )
              .slice(0, 1000) // show only the 1000 most popular
              .map((font) => font.family);

            commit('SET_GOOGLE_FONTS', fonts);
            resolve(fonts);
          })
          .catch(reject);
      });
      commit('SET_GOOGLE_FONTS_PROMISE', googleFontsPromise);

      return googleFontsPromise;
    },
    logError({ state }, error) {
      try {
        fetch(`${state.apiBaseUrl}logs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(error),
        });
      } catch (err) {
        console.warn(err);
      }
    },
  },
};
